import UpdateTickerBar from '@/pages/home/components/UpdateTickerBar';
import Hero from '@/pages/home/components/Hero';
import LatestUpdates from '@/pages/home/components/LatestUpdates';
import HotRanking from '@/pages/home/components/HotRanking';
import TimelineSection from '@/pages/home/components/TimelineSection';
import TopicWall from '@/pages/home/components/TopicWall';
import AnalysisSection from '@/pages/home/components/AnalysisSection';
import CommunitySection from '@/pages/home/components/CommunitySection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 font-body text-foreground-950">
      <UpdateTickerBar />
      <main>
        <Hero />
        <LatestUpdates />
        <HotRanking />
        <TimelineSection />
        <TopicWall />
        <AnalysisSection />
        <CommunitySection />
      </main>
      <SiteFooter />
    </div>
  );
}